import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Agenda } from '../../_models/agenda';
import { AgendasService } from '../../_services/agendas.service';
import { ZonaBarrio } from '../../_models/zona-barrio';
import { ZonaBarrioService } from '../../_services/zona-barrio.service';
import { ZonaService } from '../../_services/zona.service';
import { Zona } from '../../_models/zona';
import { EstructuraFisicaService } from '../../_services/estructura-fisica.service';
import { EstructuraFisica } from '../../_models/estructura-fisica';
import { LocalizacionesService } from '../../_services/localizaciones.service';
import { Localizaciones } from '../../_models/localizaciones';
import { Dia } from '../../_models/dia';
import { Location } from '@angular/common';
import { Coordenada } from '../../_models/coordenada';
import { NgxSpinnerService } from 'ngx-spinner';

declare let jsts: any;
declare let google: any;

@Component( {
  templateUrl: 'agenda-asignar.component.html',
  selector: 'app-agenda-asignar'
} )
export class AgendaAsignarComponent implements OnInit {
  zona: Zona = new Zona();
  estFisica: EstructuraFisica = new EstructuraFisica();
  localizacion: Localizaciones = new Localizaciones();
  columnas: any[];
  agendas: Agenda[] = [];
  guardando: boolean;
  todBarrios: ZonaBarrio[];
  carInformacionInicial = true;
  dias: Dia[] = [];
  tabSeleccionado: string;
  carMapa = false;
  polCoordenadas: Coordenada[] = [];
  procesando = false;

  constructor( private navServicio: NavService,
               private router: Router,
               private route: ActivatedRoute,
               private formBuilder: FormBuilder,
               private agendasService: AgendasService,
               private zonasBarriosServicio: ZonaBarrioService,
               private zonasServicio: ZonaService,
               private location: Location,
               private estructurasFisicasServicio: EstructuraFisicaService,
               private localizacionesServicio: LocalizacionesService,
               private spinnerServicio: NgxSpinnerService,
               private conServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.cargarMapa();
    this.columnas = [
      { field: 'barrio', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_BARRIOPRINCIPAL' ), sort: true },
      { field: 'fragmento', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_DIVICIONDEBARRIO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'AGENDA.LBL_ACCION' ), sort: true },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        forkJoin( this.zonasServicio.get( params[ 'id' ] ),
          this.agendasService.obtenerPorZona( params[ 'id' ] ),
          this.zonasBarriosServicio.getAllByZona( params[ 'id' ] ) ).subscribe( ( [ zona, agendas, res1 ] ) => {
          this.zona = zona;
          this.agendas = agendas.filter( x => x.indicadorHabilitado );
          this.todBarrios = res1.filter( y => y.indicadorHabilitado );
          if ( this.todBarrios.length === 0 ) {
            this.navServicio.setMesage( 0, {
              severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'AGENDA.MSG_NOEXISTENBARRIOS' )
            } );
          }
          this.cargarDias();
          this.estructurasFisicasServicio.getById( this.zona.idEstructuraFisica ).subscribe( estructura => {
            this.estFisica = estructura;
            if ( this.estFisica.idLocalizacion !== null && this.estFisica.idLocalizacion !== '' && this.estFisica.idLocalizacion !== undefined ) {
              this.localizacionesServicio.getById( this.estFisica.idLocalizacion, true ).subscribe( localizacion => {
                this.localizacion = localizacion;
              } );
            }
            this.carInformacionInicial = false;
          } );
        } );
      }
    } );
  }

  onSubmit( dia: Dia ) {
    dia.submitted = true;
    if ( dia.formulario.valid ) {
      this.spinnerServicio.show();
      const agenda = dia.formulario.value;
      const pol = this.todBarrios.find( x => x.idZonaBarrio === dia.formulario.controls.idZonaBarrio.value );
      if ( agenda.indicadorDividirBarrio && pol && pol.poligono ) {
        this.crearAgenda( agenda, dia, pol );
      } else if ( agenda.indicadorDividirBarrio ) {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'AGENDA.MSG_NOEXISTEPOLIGONOS' )
        } );
        this.spinnerServicio.hide();
      } else {
        this.crearAgenda( agenda, dia, pol );
      }

    }
  }

  crearAgenda( agenda: Agenda, dia: Dia, poligono: ZonaBarrio ) {
    agenda.indicadorHabilitado = true;
    this.dias.map( ( s: Dia ) => {
      if ( dia.indicador === s.indicador ) {
        agenda[ s.indicador ] = true;
      } else {
        agenda[ s.indicador ] = false;
      }
    } );
    this.agendasService.agregar( agenda ).subscribe( ageCreada => {
      agenda.idAgenda = ageCreada.idAgenda;
      agenda.poligonoBarrio = poligono.poligono;
      agenda.barrio = poligono.descripcionDivisonPolitica;
      this.agendas.push( agenda );
      dia.datos = [ ...dia.datos, agenda ];
      this.actualizarAgendaBarrios();
      dia.submitted = false;
      dia.formulario.reset();
      dia.formulario.controls.indicadorDividirBarrio.setValue( false );
      if ( agenda.indicadorDividirBarrio ) {
        dia.indPoligonos = true;
        dia.ageSeleccionada = agenda;
        this.navServicio.setMesage( 1 );
        this.spinnerServicio.hide();
        setTimeout( () => {
          document.getElementById( 'mapa' + dia.indicador ).innerHTML = '<div class="grid"><div class="col-12 md:col-12 lg:col-12 text-center"><i class="fa fa-refresh fa-spin fa-fw"></i></div></div>';
          this.pintarMapa( dia );
        }, 100 );
      } else {
        this.navServicio.setMesage( 1 );
        this.spinnerServicio.hide();
      }

    } );
  }

  cargarDias() {
    this.dias.push( new Dia( 'L', 'AGENDA.LBL_LUNES', null, null, null, false, 'indicadorLunes' ) );
    this.dias.push( new Dia( 'M', 'AGENDA.LBL_MARTES', null, null, null, false, 'indicadorMartes' ) );
    this.dias.push( new Dia( 'MI', 'AGENDA.LBL_MIERCOLES', null, null, null, false, 'indicadorMiercoles' ) );
    this.dias.push( new Dia( 'J', 'AGENDA.LBL_JUEVES', null, null, null, false, 'indicadorJueves' ) );
    this.dias.push( new Dia( 'V', 'AGENDA.LBL_VIERNES', null, null, null, false, 'indicadorViernes' ) );
    this.dias.push( new Dia( 'S', 'AGENDA.LBL_SABADO', null, null, null, false, 'indicadorSabado' ) );
    this.dias.push( new Dia( 'D', 'AGENDA.LBL_DOMINGO', null, null, null, false, 'indicadorDomingo' ) );

    this.tabSeleccionado = this.dias[ 0 ].codigo;
    this.dias.map( ( d: Dia ) => {
      d.formulario = this.formBuilder.group( {
        idZonaBarrio: [ null, [ Validators.required ] ],
        indicadorDividirBarrio: [ false, [ Validators.required ] ],
      } );
      d.forPoligonos = this.formBuilder.group( {
        codigo: [ null, [ Validators.required ] ],
        fragmento: [ null, [ Validators.required ] ],
        poligono: [ null ]
      } );
      const ageDia = this.agendas.filter( x => x[ d.indicador ] );
      const datos = [];
      this.todBarrios.map( ( s: ZonaBarrio ) => {
        const a = ageDia.find( x => x.idZonaBarrio === s.idZonaBarrio && !x.indicadorDividirBarrio );
        if ( !a ) {
          datos.push( { label: s.descripcionDivisonPolitica, value: s.idZonaBarrio } );
        }
      } );
      d.items = datos;
      d.datos = ageDia;
    } );

  }

  cambioTabView( evento: any ) {
    this.tabSeleccionado = this.dias[ evento.index ].codigo;
  }

  deshabilitar( agenda: Agenda, dia: Dia ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.procesando = true;
        this.spinnerServicio.show();
        agenda.indicadorHabilitado = false;
        this.agendasService.actualizar( agenda ).subscribe( ageActualizada => {
          const a = this.agendas.findIndex( x => x.idAgenda === agenda.idAgenda );
          if ( a >= 0 ) {
            this.agendas.splice( a, 1 );
          }
          const datDia = dia.datos.findIndex( x => x.idAgenda === agenda.idAgenda );
          if ( datDia >= 0 ) {
            dia.datos.splice( datDia, 1 );
          }
          this.actualizarAgendaBarrios();
          this.procesando = false;
          this.navServicio.setMesage( 2 );
          this.spinnerServicio.hide();
        } );
      },
      reject: () => {
      }
    } );
  }

  actualizarAgendaBarrios() {
    this.dias.map( ( d: Dia ) => {
      const datos = [];
      this.todBarrios.map( ( s: ZonaBarrio ) => {
        const a = d.datos.find( x => x.idZonaBarrio === s.idZonaBarrio && !x.indicadorDividirBarrio );
        if ( !a ) {
          datos.push( { label: s.descripcionDivisonPolitica, value: s.idZonaBarrio } );
        }
      } );
      d.items = datos;
    } );
  }

  regresar() {
    this.location.back();
  }

  regFragmentos( dirty: boolean, dia: Dia ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          dia.indPoligonos = false;
          dia.forPoligonos.reset();
          dia.ageSeleccionada = null;
          dia.codExiste = false;
          dia.subPoligonos = false;
          dia.actualizar = false;
          this.polCoordenadas = [];
        },
        reject: () => {
        }
      } );
    } else {
      dia.indPoligonos = false;
      dia.forPoligonos.reset();
      dia.ageSeleccionada = null;
      dia.codExiste = false;
      dia.subPoligonos = false;
      dia.actualizar = false;
      this.polCoordenadas = [];
    }
  }

  editar( agenda: Agenda, dia: Dia ) {
    dia.ageSeleccionada = agenda;
    dia.actualizar = true;
    dia.indPoligonos = true;
    dia.forPoligonos.controls.codigo.setValue( agenda.codigo );
    dia.forPoligonos.controls.fragmento.setValue( agenda.fragmento );
    if ( dia.ageSeleccionada.poligono ) {
      this.polCoordenadas = JSON.parse( dia.ageSeleccionada.poligono );
    }
    setTimeout( () => {
      document.getElementById( 'mapa' + dia.indicador ).innerHTML = '<div class="grid"><div class="col-12 md:col-12 lg:col-12 text-center"><i class="fa fa-refresh fa-spin fa-fw"></i></div></div>';
      this.pintarMapa( dia );
    }, 100 );
  }

  guardarFragmento( dia: Dia ) {
    dia.subPoligonos = true;
    if ( dia.forPoligonos.valid && !dia.codExiste ) {
      if ( this.polCoordenadas.length > 0 ) {
        this.spinnerServicio.show();
        document.getElementById( 'mapa' + dia.indicador ).innerHTML = '<div class="grid"><div class="col-12 md:col-12 lg:col-12 text-center"><i class="fa fa-refresh fa-spin fa-fw"></i></div></div>';
        dia.ageSeleccionada.fragmento = dia.forPoligonos.controls.fragmento.value;
        dia.ageSeleccionada.codigo = dia.forPoligonos.controls.codigo.value;
        dia.ageSeleccionada.poligono = JSON.stringify( this.polCoordenadas );

        this.agendasService.actualizar( dia.ageSeleccionada ).subscribe( div => {
          const a = this.agendas.findIndex( x => x.idAgenda === dia.ageSeleccionada.idAgenda );
          if ( a >= 0 ) {
            this.agendas[ a ] = dia.ageSeleccionada;
          }
          const datDia = dia.datos.findIndex( x => x.idAgenda === dia.ageSeleccionada.idAgenda );
          if ( datDia >= 0 ) {
            dia.datos[ datDia ] = dia.ageSeleccionada;
          }
          this.spinnerServicio.hide();
          this.navServicio.setMesage( 2 );
          this.regFragmentos( false, dia );
        } );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'DIVISIONPOLITICA.MSG_DEBESELECCIONARPOLIGONO' )
        } );
      }
    }
  }

  cargarMapa() {
    setTimeout( () => {
      if ( google ) {
        console.log( 'Maps disponible.' );
      }
    }, 500 );
  }

  pintarMapa( dia: Dia ) {
    let latLng;
    latLng = new google.maps.LatLng( 7.1253900, -73.1198000 );

    let mapOptions = {
      center: latLng,
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    const mapa = new google.maps.Map( document.getElementById( 'mapa' + dia.indicador ), mapOptions );

    let hijos = [];
    let hijPoligonos = [];
    var polPadre;
    var bounds = new google.maps.LatLngBounds();
    var center = null;

    const puntos = JSON.parse( dia.ageSeleccionada.poligonoBarrio );
    for ( let i = 0; i < puntos.length; i++ ) {
      bounds.extend( puntos[ i ] );
    }
    center = bounds.getCenter();
    mapa.set( 'center', center );
    mapa.fitBounds( bounds );


    hijos = dia.datos.filter( x => x.poligono && x.poligono.length > 0 && x.idAgenda !== dia.ageSeleccionada.idAgenda );
    polPadre = new google.maps.Polygon( {
      paths: JSON.parse( dia.ageSeleccionada.poligonoBarrio ),
      strokeColor: '#333333',
      strokeWeight: 2,
      fillColor: '#D5D5D5',
      fillOpacity: 0.5,
      clickable: true,
      editable: false,
      title: dia.ageSeleccionada.barrio
    } );

    polPadre.setMap( mapa );


    hijos.map( ( s: Agenda ) => {
      var polHijo = new google.maps.Polygon( {
        paths: JSON.parse( s.poligono ),
        strokeColor: '#333333',
        strokeWeight: 2,
        fillColor: '#2E2EFE',
        fillOpacity: 0.5,
        clickable: true,
        editable: false,
        title: s.fragmento
      } );
      hijPoligonos.push( polHijo );
      polHijo.setMap( mapa );
    } );
    var newPoligon;
    if ( dia.ageSeleccionada.poligono && dia.ageSeleccionada.poligono.length > 0 ) {
      newPoligon = new google.maps.Polygon( {
        paths: JSON.parse( dia.ageSeleccionada.poligono ),
        strokeColor: '#333333',
        strokeWeight: 2,
        fillColor: '#2E2EFE',
        fillOpacity: 0.5,
        clickable: true,
        editable: false,
        title: dia.ageSeleccionada.fragmento
      } );
      newPoligon.setMap( mapa );
    }

    var drawingManager = new google.maps.drawing.DrawingManager( {
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON ]
      },
      markerOptions: {
        icon: 'images/car-icon.png'
      },
      circleOptions: {
        fillColor: '#ffff00',
        fillOpacity: 1,
        strokeWeight: 5,
        clickable: false,
        editable: true,
        zIndex: 1
      },
      polygonOptions: {
        fillColor: '#2EFE2E',
        fillOpacity: 0.5,
        strokeWeight: 2,
        strokeColor: '#0B610B',
        clickable: true,
        editable: false,
        zIndex: 1
      }
    } );
    drawingManager.setMap( mapa );

    const valLimites = function( geometryFactory, polygon ) {
      var path = polygon.getPath();
      var coordinates = path.getArray().map( function name( coord ) {
        return new jsts.geom.Coordinate( coord.lat(), coord.lng() );
      } );
      coordinates.push( coordinates[ 0 ] );
      var shell = geometryFactory.createLinearRing( coordinates );
      return geometryFactory.createPolygon( shell );
    };

    const obtenerPoligono = function( polygon ) {
      const coorde = [];
      for ( var i = 0; i < polygon.getPath().getLength(); i++ ) {
        var xy = polygon.getPath().getAt( i );
        const nuevasCord = new Coordenada();
        nuevasCord.lat = xy.lat();
        nuevasCord.lng = xy.lng();
        coorde.push( nuevasCord );
      }
      return coorde;
    };
    let polPrevio;
    google.maps.event.addListener( drawingManager, 'polygoncomplete', ( polygon ) => {
      var rept = false;
      var geometryFactory = new jsts.geom.GeometryFactory();
      for ( let i = 0; i < hijPoligonos.length; i++ ) {
        var polCreado = valLimites( geometryFactory, polygon );
        var polOtro = valLimites( geometryFactory, hijPoligonos[ i ] );

        try {
          var intersection = polCreado.intersection( polOtro );
          if ( intersection.getCoordinates().length > 0 ) {
            rept = true;
            break;
          }
        } catch ( err ) {
          rept = true;
          break;
        }
      }

      try {
        var polCreado = valLimites( geometryFactory, polygon );
        var polOtro = valLimites( geometryFactory, polPadre );
        if ( !polOtro.contains( polCreado ) ) {
          rept = true;
        }
      } catch ( err ) {
        rept = true;
      }


      if ( rept ) {
        polygon.setMap( null );
      } else {
        if ( polPrevio ) {
          polPrevio.setMap( null );
        }
        if ( newPoligon ) {
          newPoligon.setMap( null );
          newPoligon = null;
        }
        this.polCoordenadas = obtenerPoligono( polygon );
        polPrevio = polygon;
      }

    } );

  }

  validarCodigo( dia: Dia ) {
    dia.codExiste = dia.datos.find( x => x.codigo && x.codigo === dia.forPoligonos.controls.codigo.value && x.idAgenda !== dia.ageSeleccionada.idAgenda ) != undefined ? true : false;
  }

}
